module.exports = __webpack_public_path__ + "img/im.867a7ad8.svg";